import React, { useState } from "react";
import { Menu, X, Calendar, Mail, Phone, MessageSquare, ChevronDown } from 'lucide-react';
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import Reviews from "./components/Reviews";
import EventFormats from "./components/EventFormats";
import Contact from "./components/Contact";
import FAQ from "./components/FAQ";

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm shadow-md border-b border-pink-300/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Calendar className="w-8 h-8 text-pink-300" />
              <span className="ml-2 text-xl font-bold text-white">Alice Lets go</span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection("home")} className="text-gray-300 hover:text-pink-300 transition">Главная</button>
              <button onClick={() => scrollToSection("portfolio")} className="text-gray-300 hover:text-pink-300 transition">Портфолио</button>
              <button onClick={() => scrollToSection("reviews")} className="text-gray-300 hover:text-pink-300 transition">Отзывы</button>
              <button onClick={() => scrollToSection("events")} className="text-gray-300 hover:text-pink-300 transition">Форматы</button>
              <button onClick={() => scrollToSection("contact")} className="text-gray-300 hover:text-pink-300 transition">Контакты</button>
              <button onClick={() => scrollToSection("faq")} className="text-gray-300 hover:text-pink-300 transition">FAQ</button>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white">

              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen &&
        <div className="md:hidden bg-black border-t border-pink-300/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button onClick={() => scrollToSection("home")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">Главная</button>
              <button onClick={() => scrollToSection("portfolio")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">Портфолио</button>
              <button onClick={() => scrollToSection("reviews")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">Отзывы</button>
              <button onClick={() => scrollToSection("events")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">Форматы</button>
              <button onClick={() => scrollToSection("contact")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">Контакты</button>
              <button onClick={() => scrollToSection("faq")} className="block w-full text-left px-3 py-2 text-gray-300 hover:bg-pink-300/10 rounded">FAQ</button>
            </div>
          </div>
        }
      </nav>

      {/* Main Content */}
      <main className="pt-16">
        <Hero scrollToSection={scrollToSection} />
        <Portfolio />
        <Reviews />
        <EventFormats />
        <Contact />
        <FAQ />
      </main>

      {/* Footer */}
      <footer className="bg-black text-white py-12 border-t border-pink-300/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <Calendar className="w-8 h-8 text-pink-300" />
                <span className="ml-2 text-xl font-bold">Алисия Московская</span>
              </div>
              <p className="text-gray-400">Создаю незабываемые моменты для любого события.</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Быстрые ссылки</h3>
              <div className="space-y-2">
                <button onClick={() => scrollToSection("portfolio")} className="block text-gray-400 hover:text-pink-300 transition">Портфолио</button>
                <button onClick={() => scrollToSection("events")} className="block text-gray-400 hover:text-pink-300 transition">Форматы событий</button>
                <button onClick={() => scrollToSection("contact")} className="block text-gray-400 hover:text-pink-300 transition">Связаться</button>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Контакты</h3>
              <div className="space-y-2 text-gray-400">
                <div className="flex items-center">
                  <Phone className="w-4 h-4 mr-2" />
                  <span>+7 (905) 728-88-21</span>
                </div>
                <div className="flex items-center">
                  <Mail className="w-4 h-4 mr-2" />
                  <span>m5m@ya.ru</span>
                </div>
                <div className="flex items-center">
                  <MessageSquare className="w-4 h-4 mr-2" />
                  <span>Доступна круглосуточно</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-pink-300/20 text-center text-gray-400">
            <p>&copy; 2024 Алисия Московская. Все права защищены. Создано с Lumi.</p>
          </div>
        </div>
      </footer>
    </div>);

}

export default App;